import { API_PREFIX } from '@/infrastructure/axios/code';

export const REDIRECT_URL = `https://${location.host}/v4/api/login/callback`;

export const IOA_LOGIN_URL = 'https://login.woa.tencent.com/modules/passport/signin.ashx?oauth=true';

export const IOA_CALLBACL_URL = `https://${location.host}/${API_PREFIX}/api/login/ioa-callback`;

// 太湖应用id
export const IOA_PAASID = 'bugly';
